import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ABOUT_COPY } from '../components/about/aboutCopy';
import { AboutHero, AboutTeam, AboutDiff, AboutCommit, AboutMotto, AboutCta } from '../components/about/AboutSections';

export default function AboutUs() {
  const { language } = useLanguage();
  const c = ABOUT_COPY[language === 'en' ? 'en' : 'fr'];

  useEffect(() => {
    document.title = c.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', c.meta);
  }, [c]);

  return (
    <div className="min-h-screen pt-24 md:pt-[120px] bg-white" data-testid="about-page">
      <AboutHero c={c} />
      <AboutTeam c={c} />
      <AboutDiff c={c} />
      <AboutCommit c={c} />
      <AboutMotto c={c} />
      <AboutCta c={c} />
    </div>
  );
}
